module.exports = __webpack_public_path__ + "img/logo.6f2565a3.svg";